import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RangeSlider from '../../slider/RangeSlider';


const containerStyle = {
  width: '100%',
  textAlign: 'center',
};

class AttitudeAgreeChoice extends Component {
  constructor(props) {
    super(props);
    this.handleSliderChange = this.handleSliderChange.bind(this);
  }

  getSliderCurrentValue = choice => {
    let selectedOption = 0;
    if (this.props.options.length > 0) {
      _.forEach(this.props.options, (item, index) => {
        if (item === choice) {
          selectedOption = index;
        }
      });
      return selectedOption;
    }
  };

  handleSliderChange(rangeIndex) {
    this.props.updateAttitudeAgreeChoice(this.props.options[rangeIndex]);
  }

  render() {
    return (
      <div className="row expanded">
        <div className="large-12 medium-12 small-12 columns">
          <div style={containerStyle}>
            <RangeSlider
              onChange={this.handleSliderChange}
              startPosition={this.getSliderCurrentValue(
                this.props.insight360AttitudeAgreeChoice,
              )}
              min={0}
              max={this.props.options.length}
              step={1}
              labels={this.props.options}
            />
          </div>
        </div>
      </div>
    );
  }
}

AttitudeAgreeChoice.propTypes = {
  updateAttitudeAgreeChoice: PropTypes.func,
  insight360AttitudeAgreeChoice: PropTypes.string,
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(AttitudeAgreeChoice);
